import { render, staticRenderFns } from "./my-houses.vue?vue&type=template&id=5f8ac581&scoped=true&"
import script from "./my-houses.vue?vue&type=script&lang=js&"
export * from "./my-houses.vue?vue&type=script&lang=js&"
import style0 from "./my-houses.vue?vue&type=style&index=0&id=5f8ac581&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8ac581",
  null
  
)

component.options.__file = "my-houses.vue"
export default component.exports